import React from 'react';
import Dealers from "./Dealers";

class Testimonials extends React.Component  {
    render() {
        return(
            <div>
            <section className="content-section-02 products-section-dark">
                <div className="container">
                    <div className="section-title text-center">
                        <h2>Our Happy Customers</h2>
                    </div>
                    <div className="row mb-d-30">
                        <div className="col-md-6 col-lg-6 mb--30">
                            <iframe className='you_tube' width="100%" height="400" src="https://www.youtube.com/embed/DAggT6KO2Ik" title="Customer testimonial" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                        <div className="col-md-6 col-lg-6 mb--30">
                            <iframe className='you_tube' width="100%" height="400" src="https://www.youtube.com/embed/O29p_VNmszE" title="Customer Testimonial" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </section>
        {/*<Dealers />*/}
        </div>
        );
    }
}



export default Testimonials;



// WEBPACK FOOTER //
// ./src/components/Testimonials.js